import { render, staticRenderFns } from "./ReportsPackagesCompleted.vue?vue&type=template&id=ab166128&"
import script from "./ReportsPackagesCompleted.vue?vue&type=script&lang=js&"
export * from "./ReportsPackagesCompleted.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports